import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Modal, Button, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { StyledButton } from '../UI';

import './project.modules.css';

const ProjectItemModal = ({ project = null, showModal, setShowModal, onSaveChangesHandler }) => {

    const initialState = {
        id: null,
        name: '',
        description: '',
        projectGuid: null,
        localizationId: null,
        projectAuthData: {
            clientId: '',
            clientSecret: '',
            ref: ''
        }
    };

    const dispatch = useDispatch();
    const [projectItem, setProjectItem] = useState(initialState);
    const languages = useSelector(state => state.catalogs.languages).filter(lng => lng.id === 1 || lng.id === 3);
    const [currentLanguage, setCurentLanguage] = useState(null);
    const isEditMode = project ? true : false;

    useEffect(() => {
        setProjectItem(project ? project : { ...initialState });
    }, [project]);

    const onChangeLocalizationHandler = ({ value }) => {
        setProjectItem(state => {
            const newState = { ...state };
            if (parseInt(value) === 0) {
                newState.localizationId = null
            } else {
                newState.localizationId = parseInt(value);
            }
            return newState;
        });
    };

    const onChangeNameHandler = ({ value }) => {
        setProjectItem(state => {
            const newState = { ...state };
            newState.name = value;
            return newState;
        });
    };

    const onChangeDescriptionHandler = ({ value }) => {
        setProjectItem(state => {
            const newState = { ...state };
            newState.description = value;
            return newState;
        });
    };

    const onChangeClientId = ({ value }) => {
        setProjectItem(state => {
            const newState = { ...state };
            newState.projectAuthData = { ...newState.projectAuthData, clientId: value};
            return newState;
        });
    };

    const onChangeClientSecret = ({ value }) => {
        setProjectItem(state => {
            const newState = { ...state };
            newState.projectAuthData = { ...newState.projectAuthData, clientSecret: value };
            return newState;
        });
    };

    const onChangeRef = ({ value }) => {
        setProjectItem(state => {
            const newState = { ...state };
            newState.projectAuthData = { ...newState.projectAuthData, ref: value };
            //newState.projectAuthData.ref = value;
            return newState;
        });
    };

    const onSaveHandler = () => {
        onSaveChangesHandler(projectItem);
        setProjectItem(initialState);
        setShowModal(false);

    };

    const onCancelHandler = () => {
        setProjectItem({ ...initialState });
        setShowModal(false);
    };

    //const saveGasStationHandler = async () => {
    //    if (gasStationItem.id === null) {
    //        await dispatch(addGasStation(gasStationItem));
    //    } else {
    //        await dispatch(editGasStation(gasStationItem));
    //    }
    //    await dispatch(fetchGasStations());
    //    gasStationItem(initialState);
    //    //onFinishHandler();
    //    setShowModal(false);
    //};



    return (
        <Modal
            isOpen={showModal}
            toggle={() => setShowModal(false)}
        >
            <ModalHeader toggle={() => setShowModal(false)}>
                {isEditMode ? "Редактировать поект" : "Добавить проект"}
            </ModalHeader>
            <ModalBody>
                <div className="modal-row">
                    <div className='row-name'>Локализация</div>
                    <div className='row-input'>
                        <Input
                            id="languageSelect"
                            name="languageSelect"
                            type="select"
                            value={projectItem.localizationId == null ? 0 : projectItem.localizationId}
                            onChange={e => onChangeLocalizationHandler(e.target)}
                        >
                            {projectItem.localizationId == null &&
                                <option
                                    key={0}
                                    value={0}
                                >
                                    Не выбрана локализация
                                </option>
                            }

                            {languages?.map(language => {
                                return (
                                    <option
                                        key={language.id}
                                        value={language.id}
                                    >
                                        {language.name}
                                    </option>
                                )

                            })}
                        </Input>
                    </div>
                </div>
                <div className="modal-row">
                    <div className='row-name'>Наименование:</div>
                    <div className='row-input'><Input value={projectItem.name} onChange={e => onChangeNameHandler(e.target)} /></div>
                </div>
                <div className="modal-row">
                    <div className='row-name'>Описание:</div>
                    <div className='row-input'><Input value={projectItem.description} onChange={e => onChangeDescriptionHandler(e.target)} /></div>
                </div>
                <div className="modal-row">
                    <div className='row-name'>ИД клиента:</div>
                    <div className='row-input'><Input value={projectItem.projectAuthData.clientId} onChange={e => onChangeClientId(e.target)} /></div>
                </div>
                <div className="modal-row">
                    <div className='row-name'>Секрет клиента:</div>
                    <div className='row-input'><Input value={projectItem.projectAuthData.clientSecret} onChange={e => onChangeClientSecret(e.target)} /></div>
                </div>
                <div className="modal-row">
                    <div className='row-name'>ИД реферала:</div>
                    <div className='row-input'><Input value={projectItem.projectAuthData.ref} onChange={e => onChangeRef(e.target)} /></div>
                </div>
                {projectItem.projectGuid &&
                    <div className="modal-row">
                        <div className='row-name'>GUID:</div>
                        <div className='row-input'><Input value={projectItem.projectGuid} disabled /></div>
                    </div>
                }
            </ModalBody>
            <ModalFooter>
                <Button
                    color="primary"
                    onClick={onSaveHandler}
                >
                    Сохранить
                    </Button>
                {' '}
                <Button onClick={onCancelHandler}>
                    Отменить
                    </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ProjectItemModal;